import Chart from "chart.js/auto";
import { formatColumns } from "../../../../lib/Utility";

export const tooltipPositionPlugin = (props) => {
  const {activeParagon, sizeMedia} = props
  const tooltipPlugin = Chart.registry.getPlugin("tooltip");

  tooltipPlugin.positioners.custom = function(elements) {
    const pos = tooltipPlugin.positioners.average(elements);

    // SE NON TROVA NIENTE
    if (pos === false) {
      return false;
    }

    const tooltip = this;
    const chartWidth = tooltip.chart.width;
    tooltip.realX = pos.x;

    const numColumns = formatColumns(elements)
    const tooltipWidth = 230 * (activeParagon ? (numColumns / 2) : numColumns);

    ///SE SI E' OLTRE LA META' DEL GRAFICO
    if (pos.x > chartWidth / 2) {
      const posToolLarge = (pos.x - tooltipWidth) - 150
      const posToolSmart = ((pos.x - tooltipWidth) -10) > 0 ? (pos.x - tooltipWidth) - 10 : -30
      return {
        x: sizeMedia ? posToolLarge : posToolSmart,
        y: 0,
      };
    } else {
      ///SE SI E' PRIMA DELLA LA META' DEL GRAFICO
      return {
        x: pos.x + (sizeMedia ? 50 : 10),
        y: 0,
      };
    }
  }
}
